import React from "react";
import { Modal } from "react-bootstrap";
import CliamViewResponse from "./view-claim/CliamViewResponse";

const ViewClaimResponseModal = ({ show, setShow, row }) => {
    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            scrollable
            // fullscreen="xl-up"
            dialogClassName="fullscreen-modal  ml-6 mr-6"
        >
            <Modal.Header closeButton>
                <h5 className="fs-10">View Claim </h5>
            </Modal.Header>
            <Modal.Body>
                <CliamViewResponse row={row} show={show} />
            </Modal.Body>
        </Modal>
    );
};

export default ViewClaimResponseModal;
